import React from 'react';

function UserConversationView() {
    return <div className="conversation-view">UserConversationView</div>;
}

export default UserConversationView;
